import React from 'react'

const Loading = ({showText=false, defaultHide=false}) => {
    return (
        <div className="container_12 loading" style={{display: defaultHide ? "none" : "flex", justifyContent: "center", position: "relative", flexDirection: "column", alignItems: "center", marginTop: "20px"}}>
            <div className="lds-ring" style={{right: "0", height: "134px", width: "134px"}}>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            {showText && <h1 style={{ marginTop: "2em" }}>Loading One Inc Payment Portal...</h1>}
        </div>
    )
}

export default Loading